// extracted by mini-css-extract-plugin
export default {"addToCartControl":"LY-z","giftCard":"MY-z","btnContainer":"NY-z","cartButton":"OY-z","disabled":"PY-z"};